/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeploymentMigrationInfo { 
    /**
     * Flag to indicate whether the given deployment was migrated after legacy VCDR deployment
     */
    migrated?: boolean;
    /**
     * Operator User who triggered the migration
     */
    migrated_by?: string;
    migrated_date?: Date;
}

